import React, { useState } from 'react'
import { Pressable, TextInput, View } from 'react-native'
import { ActivityIndicator } from 'react-native-paper'

import { SafeAreaView } from 'react-native-safe-area-context'
import { StatusBar } from 'expo-status-bar'
import { router } from 'expo-router'

import { DS } from '@/design-system'
import { useStore } from '@/models'

import { Header } from '@/components/Mini/Header'
import { deleteAccountSheetModal } from '@/screens/profile-screen/DeleteAccountSheetModal'

function useUpdateUsername() {
  const {
    session: { user, updateUsername, checkIsUsernameTaken }
  } = useStore()

  const [userName, setUserName] = useState(user?.name?.slice(0, 15) ?? '')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  function handleChangeName(value: string) {
    setErrorMsg('')
    setUserName(value)
  }

  async function handleSave() {
    if (!userName.trim()) return
    setIsLoading(true)
    try {
      const isUsernameTaken = await checkIsUsernameTaken(userName)
      if (isUsernameTaken) {
        setErrorMsg(`The username ${userName} is already taken`)
        return
      }
      await updateUsername(userName)
      router.back()
    } catch (error) {
      setErrorMsg('Could not save. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return { userName, handleChangeName, isLoading, errorMsg, handleSave }
}

function SettingsScreen() {

  const {
    session: { user }
  } = useStore()
  const { userName, handleChangeName, isLoading, errorMsg, handleSave } = useUpdateUsername()

  const invalidUserName = userName.trim().length === 0

  function handleCancel(){
    router.back()
  }

  function handleDelete(){
   deleteAccountSheetModal.current?.present()
  }

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: DS.palette['Brand/Cream'] }} edges={['top', 'bottom']}>
      <StatusBar style="dark" />

      <View style={{ flex: 1 }}>
        <ScreenHeader />

        <View style={{ marginHorizontal: 24, flex: 1 }}>
          <View style={{ gap: 24, borderRadius: 16, padding: 24, backgroundColor: DS.palette['Global/White'] }}>
            <InputControl
              label="Poker Name"
              value={userName}
              onChangeText={handleChangeName}
              errorMsg={errorMsg}
              maxLength={15}
            />
            <InputControl 
              label="Email" 
              placeholder={user?.email ?? ''} 
              value={user?.email ?? ''} 
              editable={false} 
            />
            
            {/*screen is temp read only, replace interactive btns with ok btn*/}
            <View style={{flexDirection: "row", justifyContent: "center" }}>
              <DS.Button style={{}} variant="Medium/Primary" type="On Light" onPress={handleCancel}>
                OK
              </DS.Button>
            </View>
            <Btns onSave={handleSave} onCancel={handleCancel} onDelete={handleDelete} isLoading={isLoading} disabled={invalidUserName} />

          </View>
        </View>
      </View>
    </SafeAreaView>
  )
}

function ScreenHeader() {

  const icon = 'Global/Black'
  const accent = 'Global/Black'

  function handleBack() {
    router.back()
  }

  return (
    <Header 
      title="Account"
      handler={handleBack} 
      theme={{ icon, accent }} 
      variant="Heading 3/Medium"   
      showKey={false} 
    />
  )
}

function InputControl(
  { label, placeholder, value, onChangeText, editable = false, errorMsg, maxLength }: 
  { label: string, placeholder?: string, value: string, onChangeText?: (value: string) => void, editable?: boolean, errorMsg?: string, maxLength?: number }) {

  //temporarily disable inputs
  //const borderColor = errorMsg
    //? DS.palette['Utility/Error']
    //: DS.palette['Global/Black']

  //const inputTextColor = editable 
    //? DS.palette['Global/Black'] 
    //: DS.palette['Brand/Dark Grey']

    const borderColor = "transparent";
    const inputTextColor = DS.palette['Global/Black'] 

  return (
    <View style={{ gap: 8 }}>

      <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
        <DS.Text variant="Mini/Bold" style={{ color: DS.palette['Brand/Dark Grey'], letterSpacing: 0.5 }} uppercase>
          {label}
        </DS.Text>

        {/*maxLength &&
          <DS.Text variant="Body Small/Regular" color={'Brand/Dark Grey'}>
            {value.length}/{maxLength}
          </DS.Text>
        */}

      </View>

      <View style={{borderColor: borderColor, flexDirection: 'row', alignItems: 'center', borderWidth: 1, borderRadius: 8, /*paddingHorizontal: 12, paddingVertical: 14,*/ width: '100%', gap: 8}}>
        <TextInput
          style={[{ color: inputTextColor, flex:1, fontSize:16, fontWeight:'500', letterSpacing:-0.25, padding:0 },{ outlineStyle: 'none' } as any ]}
          placeholder={placeholder}
          placeholderTextColor={`${DS.palette['Global/Black']}80`}
          value={value}
          onChangeText={onChangeText}
          autoCapitalize="none"
          autoCorrect={false}
          spellCheck={false}
          maxLength={maxLength}
          editable={editable}
        />
      </View>

      {errorMsg ? (
        <DS.Text variant="Body Small/Regular" style={{ color: DS.palette['Utility/Error'] }}>
          {errorMsg}
        </DS.Text>
      ) : null}

    </View>
  )
}



function Btns(
  { onSave, onCancel, onDelete, isLoading, disabled }: 
  { onSave: () => void, onCancel: () => void, onDelete: () => void, isLoading: boolean, disabled: boolean }) {

  return (
    <View style={{ gap: 24 }}>

      {/*<View style={{ flexDirection: 'row', gap: 8 }}>*/}

        {/*save btn*/}
        {/*<DS.Button
          style={{ flex: 1 }}
          variant="Medium/Primary"
          type="On Light"
          onPress={onSave}
          disabled={disabled || isLoading}
        >
          {isLoading ? <ActivityIndicator size="small" color={DS.palette['Global/White']} /> : 'Save'}
        </DS.Button>*/}

        {/*cancel btn*/}
        {/*<DS.Button style={{ flex: 1 }} variant="Medium/Secondary" type="On Dark" onPress={onCancel}>
          Cancel
        </DS.Button>*/}

     {/*</View>*/}

      {/*divider*/}
      <View style={{ width: '100%', backgroundColor: DS.palette['Brand/Light Grey'], height: 1 }} />

      <View style={{ flexDirection: 'row', justifyContent: 'center', padding: 24 }}>

        {/*delete btn*/}
        <Pressable onPress={onDelete}>
          <DS.Text variant="Body Small/Regular" style={{ color: DS.palette['Utility/Error'], textAlign: 'center' }}>
            Delete Account
          </DS.Text>
        </Pressable>

      </View>
    </View>
  )
}

export default SettingsScreen
